/* @flow */

import * as React from 'react';

import {colors} from '../colors';
import {CheckmarkIcon} from '../icon';
import {Body} from '../typography';

import './trial-gathering-pill-carousel.module.css';

type Props = {|
    pills: string[],
|};

const CYCLE_DURATION_SECONDS = 3;

export function TrialGatheringPillCarousel(props: Props) {
    const totalDuration = props.pills.length * CYCLE_DURATION_SECONDS;

    return (
        <div styleName='carousel-container' style={{'--total-duration': `${totalDuration}s`}}>
            {props.pills.map((pillText, index) => {
                const animationDelay = index * CYCLE_DURATION_SECONDS;
                const pillKey = getPillKey(index);

                return (
                    <div
                        key={pillKey}
                        styleName='pill'
                        style={{
                            '--animation-delay': `${animationDelay - CYCLE_DURATION_SECONDS * 3}s`,
                        }}
                    >
                        <CheckmarkIcon alignCenter={true} fill={colors.blue} size={20} />
                        <Body size='large' color='dark'>
                            {pillText}
                        </Body>
                    </div>
                );
            })}
        </div>
    );
}

const getPillKey = (index: number) => `pill-${index}`;
